import * as React from 'react';
import axios from 'axios';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Grid, TextField, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ToastContainer, toast } from 'material-react-toastify';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
import Modal from './Modal';

const useStyles = makeStyles((theme) => ({
  cssOutlinedInput: {
    '&:not(hover):not($disabled):not($cssFocused):not($error) $notchedOutline': {
      borderColor: 'lightgray',
      borderRadius: 0
    },
    '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
      borderColor: '#F78181'
    },
    '&$cssFocused $notchedOutline': {
      borderColor: '#F78181',
      borderRadius: 0
    }
  },
  textField: {
    width: '100%',
    borderRadius: 0,
    marginTop: 30
  },
  buttonS: {
    padding: '10px 20px',
    fontFamily: 'Oregano, cursive',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 600,
    background: '#f58081',
    letterSpacing: 1,
    borderRadius: 5,
    cursor: 'pointer',
    textDecoration: 'none',
    boxShadow: '0 10px 25px 0 rgb(1 45 126 / 15%)',
    opacity: 1,
    transition: 'all 0.1s ease-in',
    border: 'none',
    margin: '0px 10px',
    '&:hover': {
      opacity: 0.9
    }
  },
  notchedOutline: {},
  cssFocused: {},
  error: {},
  disabled: {}
}));
export default function NotifModal({
  open,
  close,
  notif,
  setNotif,
  title,
  setTitle,
  clickSend,
  clickCancel,
  listId
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const notifySuccess = (message) => {
    toast.success(message, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };

  const SendNotif = () => {
    console.log('listId==>', listId);
    const formData = new FormData();
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem('access');
    const userDetails = JSON.parse(localStorage.getItem('user'));
    formData.append('text', notif);
    formData.append('title', title);
    formData.append('created_by', userDetails.user_id);
    listId.forEach((item) => formData.append('to_users', item));
    console.log('FORMDATA ===>', userDetails.user_id, listId, notif, title);
    axios({
      method: 'POST',
      url: `${API_ENDPOINT}/api/notifications/`,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
      data: formData
    })
      .then((res) => {
        console.log('response', res);
        notifySuccess('Vous avez créé cette notification avec succès');
      })
      .catch((err) => {
        console.log('err', err);
      });
    clickCancel();
  };

  return (
    <Modal show={open} onClose={close}>
      <ToastContainer />
      <Typography
        align={document.body.dir === 'ltr' ? 'left' : 'right'}
        style={{ width: '100%', color: '#EC8B8B' }}
        variant="h4"
        gutterBottom
      >
        {t('Ajouternotification')}
      </Typography>
      <TextField
        className={classes.textField}
        InputProps={{
          classes: {
            root: classes.cssOutlinedInput,
            focused: classes.cssFocused,
            notchedOutline: classes.notchedOutline
          }
        }}
        fullWidth
        autoComplete="title"
        type="text"
        label=""
        style={{ backgroundColor: '#F5F5F5' }}
        placeholder={`${t('title')}...`}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <TextField
        className={classes.textField}
        InputProps={{
          classes: {
            root: classes.cssOutlinedInput,
            focused: classes.cssFocused,
            notchedOutline: classes.notchedOutline
          }
        }}
        fullWidth
        autoComplete="text"
        multiline
        rows={5}
        type="text"
        label=""
        style={{ backgroundColor: '#F5F5F5' }}
        placeholder={`${t('notification')}...`}
        value={notif}
        onChange={(e) => setNotif(e.target.value)}
      />
      <Box
        style={{
          width: '100%',
          marginTop: 50,
          display: 'flex',
          alignItems: 'center',
          justifyContent: document.body.dir === 'ltr' ? 'flex-end' : 'flex-start'
        }}
      >
        <button onClick={clickCancel} className={classes.buttonS}>
          {t('Annuler')}
        </button>
        <button onClick={SendNotif} className={classes.buttonS}>
          {t('Envoyer')}
        </button>
      </Box>
    </Modal>
  );
}
